import {Component, Input} from '@angular/core';

import {ErrorDetails} from '../../sdconnect-ext.model';

@Component({
  selector: 'gp-sdc-person-feedback-error-component',
  templateUrl: './sdc-person-feedback-error.component.html'
})
export class SdcPersonFeedbackErrorComponent {

  @Input() error: ErrorDetails;
}
